import { ActivatedRoute } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class RouteService {
    constructor(route) {
        this.route = route;
    }
    getQueryParam(paramName) {
        let queryParam = null;
        this.route.queryParams.subscribe(params => {
            queryParam = params[paramName] ? params[paramName] : null;
        });
        return queryParam;
    }
}
RouteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RouteService_Factory() { return new RouteService(i0.ɵɵinject(i1.ActivatedRoute)); }, token: RouteService, providedIn: "root" });
